export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7041.e90d20bc.jpg";